'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$002412 from "./presto.-Login-Page-View$$anon$12.js";
import * as $j_presto$002etypes$0024$002dCompact$002dGroup$0024 from "./presto.types$-Compact-Group$.js";
import * as $j_presto$002etypes$0024$002dGroup$002dCode$0024 from "./presto.types$-Group-Code$.js";
import * as $j_presto$002etypes$0024$002dRole$002dCode$0024 from "./presto.types$-Role-Code$.js";
var $p;
/** @constructor */
function $c_Lpresto_LoginPageView$$anon$11() {
  this.b4m = null;
  this.b4e = null;
  this.b4f = false;
  this.b4n = null;
  this.b4o = false;
  this.b4r = null;
  this.b4k = null;
  this.b4l = false;
  this.b4g = null;
  this.b4h = false;
  this.b4i = null;
  this.b4j = false;
  this.b4p = false;
  this.b4q = false;
  this.b4m = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.b4r = "CompactGroup";
}
export { $c_Lpresto_LoginPageView$$anon$11 as $c_Lpresto_LoginPageView$$anon$11 };
$p = $c_Lpresto_LoginPageView$$anon$11.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_LoginPageView$$anon$11;
/** @constructor */
function $h_Lpresto_LoginPageView$$anon$11() {
}
export { $h_Lpresto_LoginPageView$$anon$11 as $h_Lpresto_LoginPageView$$anon$11 };
$h_Lpresto_LoginPageView$$anon$11.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.b4m;
});
$p.M = (function() {
  if ((!this.b4f)) {
    this.b4e = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.b4f = true;
  }
  return this.b4e;
});
$p.O = (function() {
  if ((!this.b4o)) {
    this.b4n = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.b4o = true;
  }
  return this.b4n;
});
$p.E = (function() {
  return this.b4r;
});
$p.t = (function() {
  if ((!this.b4l)) {
    this.b4k = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("roles", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.b4l = true;
  }
  return this.b4k;
});
$p.N = (function() {
  if ((!this.b4h)) {
    this.b4g = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGroup$002dCode$0024.$m_Lpresto_types$GroupCode$().iK(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44($j_presto$002etypes$0024$002dRole$002dCode$0024.$m_Lpresto_types$RoleCode$().kw())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.b4h = true;
  }
  return this.b4g;
});
$p.Q = (function() {
  if ((!this.b4j)) {
    this.b4i = new $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$002412.$c_Lpresto_LoginPageView$$anon$12();
    this.b4j = true;
  }
  return this.b4i;
});
$p.v = (function() {
  if ((!this.b4q)) {
    this.b4p = false;
    this.b4q = true;
  }
  return this.b4p;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee85) => ((p) => \u03b4scrutinee85.acU(p)))($j_presto$002etypes$0024$002dCompact$002dGroup$0024.$m_Lpresto_types$CompactGroup$())));
});
var $d_Lpresto_LoginPageView$$anon$11 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_LoginPageView$$anon$11, "presto.LoginPageView$$anon$11", ({
  Mc: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_LoginPageView$$anon$11 as $d_Lpresto_LoginPageView$$anon$11 };
//# sourceMappingURL=presto.-Login-Page-View$$anon$11.js.map
